"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecodeError = void 0;
class DecodeError extends Error {
    constructor(message = '') {
        super(message);
        this.name = 'DecodeError';
        this.toString = () => `${this.message}`;
    }
}
exports.DecodeError = DecodeError;
//# sourceMappingURL=errors.js.map